import React from 'react';
import { useRouteError, Link } from 'react-router-dom';

export default function ErrorBoundary() {
  const error = useRouteError();
  console.error('Route error:', error);
  
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white dark:bg-black/95 shadow-lg rounded-lg p-8 border border-gray-200 dark:border-white/10">
        <h1 className="text-3xl font-medium text-brand mb-4">Oops!</h1>
        <p className="text-gray-700 dark:text-white/80 mb-6">
          {error?.statusText || error?.message || "Something went wrong."}
        </p>
        <div className="flex gap-3">
          <Link
            to="/"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-brand hover:bg-[#E6A15E] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand"
          >
            Go Home
          </Link>
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-white/10 text-sm font-medium rounded-md shadow-sm text-gray-700 dark:text-white/80 bg-white dark:bg-white/5 hover:bg-gray-50 dark:hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 dark:focus:ring-white/30"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
}
